import { render, staticRenderFns } from "./CrmCorpMenu.vue?vue&type=template&id=2fc23b67"
import script from "./CrmCorpMenu.vue?vue&type=script&lang=js"
export * from "./CrmCorpMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports